import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const TotalPriceOriginal = styled.del<{
  size: 'small' | 'medium' | 'large';
}>(
  ({theme, size}) => css`
    color: ${theme.colors.contentAdditionalA};
    white-space: nowrap;
    ${size === 'medium' && theme.typography.labelXSmall};
    ${size === 'large' && theme.typography.labelXSmallBold};
  `
);
